var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DEDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8258 16.6652C32.0816 16.4918 30.3375 16.3618 28.5825 16.2643V16.2535L28.3441 14.8452C28.1816 13.8485 27.9433 12.3535 25.4083 12.3535H22.57C20.0458 12.3535 19.8075 13.7835 19.6341 14.8343L19.4066 16.221C18.3991 16.286 17.3916 16.351 16.3841 16.4485L14.1741 16.6652C13.7191 16.7085 13.3941 17.1093 13.4375 17.5535C13.4808 17.9977 13.8708 18.3227 14.3258 18.2793L16.5358 18.0627C22.2125 17.4993 27.9325 17.716 33.6741 18.2902C33.7066 18.2902 33.7283 18.2902 33.7608 18.2902C34.1725 18.2902 34.53 17.976 34.5733 17.5535C34.6058 17.1093 34.2808 16.7085 33.8258 16.6652Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8324 19.817C31.5724 19.5462 31.2149 19.3945 30.8466 19.3945H17.1532C16.7849 19.3945 16.4166 19.5462 16.1674 19.817C15.9182 20.0879 15.7774 20.4562 15.7991 20.8354L16.4707 31.9504C16.5899 33.597 16.7416 35.6554 20.5224 35.6554H27.4774C31.2582 35.6554 31.4099 33.6079 31.5291 31.9504L32.2007 20.8462C32.2224 20.4562 32.0816 20.0879 31.8324 19.817ZM25.7982 30.2279H22.1907C21.7466 30.2279 21.3782 29.8595 21.3782 29.4154C21.3782 28.9712 21.7466 28.6029 22.1907 28.6029H25.7982C26.2424 28.6029 26.6107 28.9712 26.6107 29.4154C26.6107 29.8595 26.2424 30.2279 25.7982 30.2279ZM26.7082 25.8945H21.2916C20.8474 25.8945 20.4791 25.5262 20.4791 25.082C20.4791 24.6379 20.8474 24.2695 21.2916 24.2695H26.7082C27.1524 24.2695 27.5207 24.6379 27.5207 25.082C27.5207 25.5262 27.1524 25.8945 26.7082 25.8945Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.84cb738c43b51167bbada673ae5ec67a.svg";
export { ForwardRef as ReactComponent };